import {CountryCode} from 'libphonenumber-js'
import flags from 'react-phone-number-input/flags'

export default {
    get: (countryCode: CountryCode) => {
        return flags[countryCode]?.({ title: countryCode })
    }
}